module.exports = __webpack_public_path__ + "static/media/lambda-logo.ebee3fff.png";